import "./style.css";

const About = () => {
    return (
        <div className="about">
            <h1>Bio</h1>
            <p>
                Hey!. This is Dhritesh Patel from here. I am enthusiastic about programming and I love watching and playing cricket, I have done my Bachelors of engineering from the GEC Modasa, upto great extent college helped me to build my career in the programming and website development, and then after i have been able to qaulify Gate exam and successfully i have taken admission into the LD college of Engineering Where i have learnt advance programming concepts such as Advance data structure and the some website development library like react. I firmly believe that there is nothing in this world which can't be learned, just one need the dedication, resistance and the love for the learning.
        </p>
            <br />
            <p>
                I to want add that,
                I am innovative and passionate Computer Engineer with the
                ability to design and conduct experiments as well as to
                analyze and interpret complex data. First-hand skills to
                design a system, component, or process to meet desired
                needs.  
        </p>
        </div>
    )
}

export default About
